module.exports = __webpack_public_path__ + "img/Olav_og_Kari_Magnus_Brostrup_Landstad.1c72695d.jpg";